<template>
  <div class="modal fade" :id="id" tabindex="-1">
    <div class="modal-dialog modal-fullscreen">
      <div class="modal-content">
        <div class=" d-flex flex-row-reverse">
          <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor" />
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor" />
                    </svg>
                  </span>
          </div>
        </div>
        <div class="modal-body p-0 m-0">
          <Loader :is-loading="getting">
            <Card card="card p-5 bg-light h-100">
              <div class="">

                <Card  class="card p-5  ">
                  <template #cardHeader>
                    <div class="card-header p-5">
                      <h3 class="card-title align-items-start flex-column">
                        <span class="card-label fw-bolder text-dark">{{current?.title}} </span>
                        <span class="text-primary mt-1 fw-bold fs-4"><span class="fw-light text-black" >{{ current?.category }}</span> <span class="text-primary" v-if="current?.reference">| {{ current?.reference }}</span></span>
                        <span class="mt-1 fw-light d-flex justify-content-around">{{$t('projects.label.customer') }} : <span class="fw-bold d-flex fs-4">
                            <div v-for="(contact, idx) in contacts" :key="idx"  class="text-primary fw-bold bg-light-primary px-2 py-1 rounded mx-1 mb-1">
                              {{contact.name}} <span class="badge badge-primary">{{contact.status}}</span>
                            </div>
                          </span>
                        </span>
                        <span class="fw-light ">{{$t('projects.label.manager') }} : <span class="fw-bold fs-4">{{ current?.manager }}</span> </span>

                      </h3>
                    </div>
                  </template>
                  <div class="my-4 px-5">
                    <div>
                      <div class="d-flex flex-column flex-md-row justify-content-between mb-7">
                        <ul class="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-bold mb-3 mb-md-0">
                          <li class="nav-item">
                            <a class="nav-link text-active-primary pb-4" :class="{ 'active': isActiveTab('tasks_tab') || !currentTab }" @click="toggleTab('tasks_tab')">{{ $t('projects.overview') }}</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link text-active-primary pb-4" :class="{ 'active': isActiveTab('review_tasks_tab') }" @click="toggleTab('review_tasks_tab')">
                              {{ $t('tasks.label.beReview') }}
                              <span v-if="tasksWaitingReview.length" class="badge badge-danger ms-2">
                                {{ tasksWaitingReview.length }}
                              </span>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div class="tab-content" id="myTabContent">
                        <Loader :is-loading="isLoading">
                          <div class="tab-pane fade mh-500px scroll-y" :class="{ 'show active': isActiveTab('tasks_tab') || !currentTab }" id="tasks_tab" role="tabpanel">
                            <div class="accordion" id="kt_accordion_tasks">
                              <div class="accordion-item my-4" v-for="(step,index) in current?.step" :key="step?.id">
                                <h2 class="accordion-header" :id="'kt_accordion_1_header_'+index">
                                  <button class="accordion-button fs-4 fw-bold collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#kt_accordion_'+index" aria-expanded="true" aria-controls="kt_accordion_1_body_1">
                                    <span :class="'me-3 badge badge-'+step?.color">{{ step?.progress }}%</span>
                                    {{step?.name}}
                                    <span class="badge badge-square border border-gray-300 p-2 badge-light-primary align-self-center ms-2" :title="$t('tasks.label.reviewedBeReview')">
                                    <img src="/assets/media/tasks/validate.png" class="h-15px me-2" />
                                    {{step.totalReviewed}}/{{step.totalNeedReview}}
                                  </span>
                                  </button>
                                </h2>
                                <div :id="'kt_accordion_'+index" class="accordion-collapse collapse" :aria-labelledby="'kt_accordion_1_header_'+index" data-bs-parent="#kt_accordion_tasks">
                                  <div class="accordion-body">
                                    <StatusTaskList
                                        :id="i"
                                        :count="step?.totalTasks"
                                        v-for="(status, i) in step?.tasksByStatus"
                                        :project="current?.id"
                                        :status="status"
                                        :handleTaskSelected="handleTaskSelected"
                                        @callback="$emit('load', current?.id)"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="tab-pane fade  mh-500px scroll-y p-2" :class="{ 'show active': isActiveTab('review_tasks_tab') }" id="review_tasks_tab" role="tabpanel">
                            <div class="h-350px d-flex justify-content-center align-items-center" v-if="!tasksWaitingReview.length">
                              <div class=" text-center ">
                                <div class="pt-8 ">
                                  <Img filename="empty.png" alt=""
                                       class="mw-100 h-125px h-sm-100px" />
                                </div>
                                <h2 class="fs-2x fw-bolder mb-0">{{ $t('projects.noTaskToReview') }}</h2>
                              </div>
                            </div>
                            <Card v-else class="card shadow mb-2" v-for="task in tasksWaitingReview">
                              <template #cardBody>
                                <div class="d-flex align-items-center justify-content-between mb-2 m-2">
                                  <h3 class="align-items-start flex-column cursor-pointer">
                                    <span class="card-label fw-bolder text-dark">{{ task.title }}</span>
                                  </h3>
                                  <div>
                                    <Button @click.prevent="toggleRejectCommentModal(task.id)" btn-class="btn-sm btn-danger btn-icon me-3" icon-class="fa fa-times" type="button"></Button>
                                    <Button @click.prevent="validateTask(task.id)" btn-class="btn-sm btn-success btn-icon me-3" icon-class="fa fa-check" type="button"></Button>
                                  </div>
                                </div>
                              </template>
                            </Card>
                          </div>
                        </Loader>
                      </div>
                    </div>
                  </div>
                </Card>
              </div>
            </Card>
          </Loader>
        </div>
        <div class="modal-footer">
          <Button @click.prevent="closeModal" type="cancel" btn-class="btn" :btn-text="$t('button.close')" />
        </div>
      </div>
    </div>
  </div>
  <TaskCommentModal
      :id="id+'task_comment'"
      :form="form"
      @load="reload"/>
  <RejectTaskMotifModal
      id="tasks-reject-motif-modal"
      :submit-form="rejectTask"
      :loading="processReject"
      :motif="rejectMotif.motif"
  />
</template>

<script setup>
import { ref, defineEmits, defineProps, watch } from "vue";
import StatusTaskList from './StatusTaskList.vue';
import TaskCommentModal from './TaskCommentModal.vue';
import "vue3-colorpicker/style.css";
import { computed } from "vue";
import { useStore } from "vuex";
import Card from "@/components/Card.vue";
import Button from "@/components/Button.vue";
import i18n from "@/plugins/i18n";
import {useSwal} from "@/composables/useSwal";
import Img from "@/components/Img.vue";
import RejectTaskMotifModal from "@/Modules/Projects/views/Reports/components/RejectTaskMotifModal.vue";
import Loader from "@/components/Loader.vue";

const {showSwal} = useSwal()
const store = useStore();
const emits = defineEmits(["load"]);

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  getting: {
    type: Boolean,
    required: true,
  },
  report: {
    type: Object,
    default: () => ({
      id: "",
    }),
  },
  contacts: {type: Array, default: []}
});


const comment = ref('')
const current = ref(props.report)
const form = ref({id: '', comment: '', oldComments: []})
const selectedEmoji = ref('')
const isLoading = ref(false)
const processReject = ref(false)
const rejectMotif = ref({
  taskId: '',
  motif: ''
})
const tasksWaitingReview = ref([])

const currentTab = ref('')

const emojis = computed(() => store.getters['feeds/getReactions'])

watch(() => props.report, () => {
  current.value = props.report
  loadProjectWaitingReviewTask(props.report.id)
}, {deep: true})

function isActiveTab(tabId) {
  return currentTab.value === tabId
}

function toggleTab(tabId) {
  currentTab.value = tabId
}

const handleTaskSelected =  (task) => {
  form.value.id = task.id
  form.value.oldComments = [...task.comments.filter(el => el.type === 'TEXT')]
  //$("#" + props.id).modal("toggle");
  $('#'+props.id+'task_comment').modal('toggle')
}

function closeModal() {
  $("#" + props.id).modal("toggle");
  currentTab.value = ''
}

function reload(){
  emits('load', current.value?.id)
  // $("#" + props.id).modal("toggle");
}

function loadProjectWaitingReviewTask(projectId) {
  isLoading.value = true
  store.dispatch('projects/getProjectTaskWaitingReview', projectId)
      .then(res => {
        tasksWaitingReview.value = res.data.data
      })
      .catch(err => {})
      .finally(() => isLoading.value = false)
}


function validateTask(id) {
  showSwal(
      i18n.global.t('swal.project_task_validate'),
      i18n.global.t('swal.project_task_validate_text')
  ).then((result) => {
    if (result.value) {
      store.dispatch('tasks/validateTask', { task_ids: [id] })
          .then(res => {
            emits('load', current.value?.id)
            loadProjectWaitingReviewTask(props.report.id)
          })
          .catch(err => {})
          .finally(() => {})
    }
  })

}

function toggleRejectCommentModal(id) {
  if(id) {
    rejectMotif.value.taskId = id
  }
  rejectMotif.value.motif = ''
  // $("#" + props.id).modal("toggle");
  $('#tasks-reject-motif-modal').modal('toggle')
}
function rejectTask(motif) {
  showSwal(
      i18n.global.t('swal.project_task_reject'),
      i18n.global.t('swal.project_task_reject_text')
  ).then((result) => {
    if (result.value) {
      processReject.value = true
      store.dispatch('tasks/rejectTask', { task_id: rejectMotif.value.taskId, comment: motif })
          .then(res => {
            emits('load', current.value?.id)
            toggleRejectCommentModal()
            loadProjectWaitingReviewTask(props.report.id)
            rejectMotif.value.taskId = ''
          })
          .catch(err => {})
          .finally(() => processReject.value = false)
    }
  })
}

</script>

<style scoped>
.color-picker-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.w-90{
  width: 87% !important;
}

.nav-item {
  cursor: pointer;
}
</style>
